var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmptyStateBlockedList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmptyStateBlockedList") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.0951474,23.0430691 C99.3175226,34.3432559 101.972359,48.4611963 98.4616451,62.2955033 C96.8759835,68.5455033 94.158345,74.329519 90.3880685,79.4899875 C81.0026055,92.3330502 65.9214997,100 50.0447694,100 C45.9068518,100 41.7566424,99.4792598 37.7092383,98.4523065 C29.5232665,96.3753932 22.1595621,92.361651 16.1251174,86.7894933 L92.0951474,23.0430691 Z M9.86763238,79.8074143 C8.86416577,78.4507902 7.92309902,77.0361231 7.04864382,75.5665564 C0.222141468,64.0935097 -1.72780887,50.6458967 1.55749428,37.7011443 C7.19167743,15.5037547 27.1001675,4.61852778e-13 49.9721351,4.61852778e-13 C54.1089352,4.61852778e-13 58.2580272,0.520740211 62.3043139,1.54769355 C64.3101367,2.05502414 66.304785,2.69421598 68.2312689,3.44738959 C75.2931229,6.19954484 81.4020221,10.4261272 86.328429,15.6491881 L9.86763238,79.8074143 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icEmptyStateBlockedList",
    fill: "#666666",
    fillRule: "nonzero",
    opacity: 0.600000024,
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyStateBlockedList);
export default __webpack_public_path__ + "static/media/icEmptyStateBlockedList.9959583f16c3293c17b24e898e026e0c.svg";
export { ForwardRef as ReactComponent };